import {
  MockHook,
  useSession,
  useUser,
  useCurrentOEMBrandingEntitlements,
  useAccounts,
} from '@jupiterone/jupiter-web-toolkit';
import { useEffect, useState } from 'react';
import { useAnchorElState, useBooleanState } from 'react-use-object-state';

export interface AccountMenuProps {
  collapsed?: boolean;
}
const useAccountMenuLogic = ({ collapsed }: AccountMenuProps) => {
  const { useAccount, logout } = useSession();
  const { accounts, account } = useAccounts();
  const { user, loading } = useUser();
  const { anchorEl, setAnchorEl, clearAnchorEl } = useAnchorElState(null);
  const addAccountModalOpen = useBooleanState(false);
  const [displayName, setDisplayName] = useState<string>('');

  const branding = useCurrentOEMBrandingEntitlements();
  const hasOemBranding =
    branding?.data?.checkValueSetEntitlementAccess.items.some(
      (brand) => brand.canAccess
    ) ?? false;
  const accountName =
    (!branding?.loading && hasOemBranding && account?.name) ?? false;

  useEffect(() => {
    if (loading || !user) {
      return;
    }
    setDisplayName(user.profile.name || user.id);
  }, [user, loading]);

  return {
    accountName,
    collapsed,
    anchorEl,
    displayName,
    accounts,
    account,
    user,
    addAccountModalOpen,
    setAnchorEl,
    clearAnchorEl,
    useAccount,
    logout,
  };
};

export type AccountMenuComponentProps = ReturnType<typeof useAccountMenuLogic>;
export const MOCK_ACCOUNT_MENU_PROPS: AccountMenuComponentProps = {
  accountName: false,
  setAnchorEl: MockHook.mockFunction,
  anchorEl: null,
  displayName: 'Saturn',
  clearAnchorEl: MockHook.mockFunction,
  user: {
    profile: {
      email: 'user@email.fake',
    },
  } as any,
  useAccount: MockHook.mockFunction,
  logout: MockHook.mockFunction,
  accounts: [],
  account: undefined,
  addAccountModalOpen: {
    setTrue: MockHook.mockFunction,
    state: false,
    setFalse: MockHook.mockFunction,
    toggle: MockHook.mockFunction,
  } as any,
  collapsed: false,
};
export default MockHook.useMockHook(
  useAccountMenuLogic,
  MOCK_ACCOUNT_MENU_PROPS
);
